import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eny6fm9qyb: FaireBrandEntity = {
  token: "b_eny6fm9qyb",
  type: "brand",
  name: "Mamas Peri Peri Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/26e3b95cfa842bd1ba685dfcc11359b11190415a2bfbc3bd85c745f51795536f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/def91d4f0af5b38dcc7bfd068664ffebf9cb3711f72f4df7b010bd47b91d9b30.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/26e3b95cfa842bd1ba685dfcc11359b11190415a2bfbc3bd85c745f51795536f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/def91d4f0af5b38dcc7bfd068664ffebf9cb3711f72f4df7b010bd47b91d9b30.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 110,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Mamas Peri Peri Hot Sauce is a South African family recipe carefully blended in Denver, Colorado, in a time-honored tradition of Portuguese culinary excellence. We source only the freshest and finest ingredients. When paired with your favorite foods a taste sensation of chili, lemons, garlic, and peppers light up your senses!\nWe offer Mild, Medium and Zinger flavors so that we have a heat level for all heat preferences ! ",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:47.499Z",
    importedBy: "entity-db-cli",
  },
};
